'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoverIcon = require('../hover-icon');

var _hoverIcon2 = _interopRequireDefault(_hoverIcon);

var _proptypes = require('../util/proptypes');

var _palette = require('../../palette');

require('./styles.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var STYLE_BASE = 'zk-action-icon-';

var ActionIcon = function ActionIcon(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      height = props.height,
      Icon = props.Icon,
      iconClassName = props.iconClassName,
      fillColor = props.fillColor,
      hoverIconRef = props.hoverIconRef,
      size = props.size,
      style = props.style,
      titleTag = props.titleTag,
      width = props.width,
      testid = props.testid,
      unhover = props.unhover,
      others = _objectWithoutProperties(props, ['children', 'className', 'color', 'height', 'Icon', 'iconClassName', 'fillColor', 'hoverIconRef', 'size', 'style', 'titleTag', 'width', 'testid', 'unhover']);

  var svgProps = {};

  if (color) {
    svgProps.color = color;
  }

  if (fillColor) {
    svgProps.fillColor = fillColor;
  }

  if (size || height) {
    svgProps.height = size || height;
  }

  if (size || width) {
    svgProps.width = size || width;
  }

  return _react2.default.createElement('div', {
    style: style,
    'data-testid': testid,
    className: className
  }, _react2.default.createElement(_hoverIcon2.default, _extends({
    className: iconClassName
  }, others, {
    hoverIconRef: hoverIconRef
  }), _react2.default.createElement('div', {
    title: titleTag
  }, _react2.default.createElement(Icon, _extends({}, svgProps, {
    className: STYLE_BASE + 'iconElement'
  }))), children));
};

ActionIcon.propTypes = {
  fillColor: _propTypes2.default.string,
  height: _propTypes2.default.number,
  hoverColor: _propTypes2.default.string,
  Icon: _propTypes2.default.func,
  pressColor: _propTypes2.default.string,
  style: _proptypes.STYLE_PROP,
  width: _propTypes2.default.number,
  testID: _propTypes2.default.string,
  unhover: _propTypes2.default.bool
};
ActionIcon.defaultProps = {
  defaultColor: _palette.iconColor,
  defaultHoverColor: _palette.iconHoverColor,
  defaultPressColor: _palette.iconPressColor
};
exports.default = ActionIcon;